import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { Button } from 'rmwc/Button';
import { TextField } from 'rmwc/TextField';
import ReactExport from "react-data-export";
import { ListDivider } from 'rmwc/List';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'


class AdminSeminarList extends Component {

  constructor(props){
    super(props);
    this.state = {
      errorMsg: '',
      downloadDisable: true,
      seminarUserDownloadDisable: true,
      reportDownloadDisable: false,
      resourceDownloadDisable: true,
      data:{
        page: 1,
        totalPages: '',
        seminars: [],
        exportData: [],
        seminarUserExportData: [],
        startSeminarExport: 1,
        endSeminarExport: 100,
        selectedSeminarIdExport: '',
        seminarUserId: '',
        resourceExport: [],
      }
    }
  }

  componentDidMount(){
    this.fetchSeminarList()
  }

  fetchSeminarList = (e) => {
    let data = Object.assign({}, this.state.data)
    const page_no = this.state.data.page
    let url = `admin/seminars/list/${page_no}`
    api.getResponse(this.props.user.accessToken, url).then((result) => {
        const { status, errors} = result
        if (status === 'error') {
          this.setState({ errorMsg: 'Error in Fetching Detail' })  
        }
        if (status === 'success') {
          data.seminars = result.data
          data.totalPages = result.page_count
          this.setState({data:data})
        }
    })
    .catch((err) => {
      this.setState({ errorMsg: 'Error in Fetching Details' })
    })
  }

  handleSeminarView = (e, seminar_id) => {
    e.preventDefault();
    let id = seminar_id
    this.props.history.push(`/portal/app/admin/seminar/change/${id}`)
  }

  onPageTextChange = evt => {
    let data = Object.assign({}, this.state.data);
    data.page = evt.target.value;
    this.setState({data:data});
  }

  handleFetch = (e) => {
    e.preventDefault()
    this.fetchSeminarList()
  }

  onInputChange = (e) => {
    let data = Object.assign({}, this.state.data)
    data[e.target.name] = e.target.value;
    this.setState({data: data})
  }

  handleExportData = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    let errorMsg = this.state.errorMsg
    if(!this.state.downloadDisable){
      this.setState({ downloadDisable: true })
    }

    let startId = parseInt(this.state.data.startSeminarExport)
    let endId = parseInt(this.state.data.endSeminarExport)
    let url = `admin/fetch/seminar/export/${startId}/${endId}`
    api.getResponse(this.props.user.accessToken, url)
    .then((result)=> {
      if(result.status === 'success'){
        data.exportData = result.data
        errorMsg = result.message
        this.setState({ data: data, errorMsg: errorMsg, downloadDisable: false })
      }

      else if(result.status === 'error'){
        errorMsg = result.message
        this.setState({ errorMsg: errorMsg})
      }
    }) 
    .catch((err) => {
      this.setState({ errorMsg: 'Error in Fetching Details' })
    })
  }

  handleSeminarUserExportData = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    let errorMsg = this.state.errorMsg

    if(!this.state.seminarUserDownloadDisable){
      this.setState({ seminarUserDownloadDisable: true })
    }

    if(this.state.data.selectedSeminarIdExport === '' || this.state.data.selectedSeminarIdExport === null || this.state.data.selectedSeminarIdExport === undefined ){
      errorMsg = "Seminar Id is not valid."
      this.setState({ errorMsg: errorMsg })
      return
    }

    let seminarId = parseInt(data.selectedSeminarIdExport)
    let url = `admin/fetch/seminar/details/export/${seminarId}`
    api.getResponse(this.props.user.accessToken, url)
    .then((result) =>{
      if(result.status === 'success'){
        data.seminarUserExportData = result.data
        errorMsg = result.message
        this.setState({ data: data, errorMsg: errorMsg, seminarUserDownloadDisable: false })
      }
      else if(result.status === 'error'){
        errorMsg = result.message
        this.setState({ errorMsg: errorMsg })
      }
    })
    .catch((err) => {
      this.setState({ errorMsg: 'Error in Fetching Details' })
    })
  }

  handleRendering = (e, urlInput, type, certificationType, uploadType) => {
    if(certificationType === 0 && urlInput === 'view'){
      this.props.history.push(`/portal/app/admin/hallticket/${urlInput}/${type}/${certificationType}/${uploadType}`)
    }
    else{
      this.props.history.push(`/portal/app/admin/hallticket/${urlInput}/${type}/${uploadType}`)
    }
  }

  fetchSpecificReport = (e) => {
    e.preventDefault()
    let seminar_user_id = this.state.data.seminarUserId
    this.setState({reportDownloadDisable: true})
    api.downloadAdminSeminarReport(this.props.user.accessToken, this.state.data.seminarUserId)
    .then((result) => {
       if (result instanceof Blob){
        this.setState({ errorMsg: '', reportDownloadDisable: false })
        const url = window.URL.createObjectURL(result);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${seminar_user_id}_certificate.pdf`);
        document.body.appendChild(link);
        link.click();
      }
      else{
        this.setState({ reportDownloadDisable: false, errorMsg: 'Unable to download reports. Please contact Administrator' })
      }      
    }).catch((err) => {
        this.setState({ reportDownloadDisable: false, errorMsg: 'Unable to downlod reports. Please contact Admin' })
    })
  }

  handleResourceExport = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    let url = `admin/lr/get/all/posts`
    this.setState({resourceDownloadDisable: true})
    api.getResponse(this.props.user.accessToken, url).then((result) => {
      if(result.status === 'success'){
        data.resourceExport = result.data
        this.setState({data: data, resourceDownloadDisable: false})
      }
      else if(result.status === 'error'){
        this.setState({errorMsg: result.message})
      }
    }).catch((err) => {
      this.setState({errorMsg: 'Exception. Please contact Administrator' })
    })
  }

  render() {
    let seminarListComponent;
    let activeState;
    let handleSeminarView = this.handleSeminarView
  
    /* Start of export component */
    let seminarUserExportComponent, seminarListExportComponent
    let ExcelFile = ReactExport.ExcelFile;
    let ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    let ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    seminarListExportComponent = (
      <GridCell span="6">
        <TextField className = "text_input" label = "Seminar Id From" name = "startSeminarExport" onChange = {this.onInputChange} value = {this.state.data.startSeminarExport}/>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <TextField className = "text_input" label = "Seminar Id To" name = "endSeminarExport" onChange = {this.onInputChange} value = {this.state.data.endSeminarExport}/>
        <Button Button dense onClick= {this.handleExportData}>Export</Button>
        <ExcelFile element={<Button disabled={this.state.downloadDisable}>Download</Button>}>
            <ExcelSheet data={this.state.data.exportData} name="seminarexport">
              <ExcelColumn label="Seminar Id" value="id"/>
              <ExcelColumn label="Seminar Name" value="name"/>
              <ExcelColumn label="Seminar Full Name" value="full_name"/>
              <ExcelColumn label="Description" value="description"/>
              <ExcelColumn label="Event Date" value="event_date"/>
              <ExcelColumn label="Registration Link" value="reg_link"/>
              <ExcelColumn label="Active" value="active"/>
              <ExcelColumn label="Image Link" value = "icon_link"/>
              <ExcelColumn label="Listing Sequence" value="listing_sequence"/>
              <ExcelColumn label="Session No" value="session_no"/>
              <ExcelColumn label="Resource Id" value="ext_resource_id"/>
              <ExcelColumn label="Created At" value="created_at"/>
              <ExcelColumn label="Updated At" value="updated_at"/>
            </ExcelSheet>
        </ExcelFile>
      </GridCell>
      )

    seminarUserExportComponent = (
      <GridCell span="4">
          <TextField className = "text_input" label = "Individual Seminar Id" name = "selectedSeminarIdExport" onChange = {this.onInputChange} value = {this.state.data.selectedSeminarIdExport}/>
          <Button Button dense onClick= {this.handleSeminarUserExportData}>Export</Button>
          <ExcelFile element={<Button disabled={this.state.seminarUserDownloadDisable}>Download</Button>}>
            <ExcelSheet data={this.state.data.seminarUserExportData} name="seminaruserexport">
              <ExcelColumn label="Certificate Id" value="certificate_id"/>
              <ExcelColumn label="Seminar Id" value="seminar_id"/>
              <ExcelColumn label="Seminar Name" value="seminar_name"/>
              <ExcelColumn label="Seminar Full Name" value="seminar_full_name"/>
              <ExcelColumn label="Event Date" value="event_date"/>
              <ExcelColumn label="User Id" value="user_id"/>
              <ExcelColumn label="User Name" value="user_name"/>
              <ExcelColumn label="Phone" value="phone"/>
              <ExcelColumn label="Email" value="email"/>
              <ExcelColumn label="User Active" value="user_active"/>
              <ExcelColumn label="First Name" value="first_name"/>
              <ExcelColumn label="Last Name" value="last_name"/>
              <ExcelColumn label="Registered Webinar" value="registered"/>
              <ExcelColumn label="Registered On" value="registered_on"/>
              <ExcelColumn label="Attended Webinar" value="participation"/>
              <ExcelColumn label="Ratings" value="ratings"/>
              <ExcelColumn label="Registration Link" src = "link" value="reg_link"/>
              <ExcelColumn label="Seminar Active" value="seminar_active"/>
              <ExcelColumn label="Session No" value="session_no"/>
              <ExcelColumn label="Report Download Count" value = "download_count" />
              <ExcelColumn label="Created at" value = "created_at" />
            </ExcelSheet>
          </ExcelFile>
      </GridCell>
    )

    let SeminarResourceExportComponent = (
      <GridCell span = "2">
        <br/>
        <Button dense onClick={this.handleResourceExport}>Resource Export</Button>
        <ExcelFile element={<Button disabled={this.state.resourceDownloadDisable}>Download</Button>}>
          <ExcelSheet data={this.state.data.resourceExport} name="Blog Export">
            <ExcelColumn label="Resource Id" value="id"/>
            <ExcelColumn label="Name" value="title"/>
          </ExcelSheet>
        </ExcelFile>
      </GridCell>
      )

     if(this.state.data.seminars.length >0){
        seminarListComponent = 
          ( <tbody>
              {this.state.data.seminars.map(function(seminar) {
                  seminar.active ? activeState='Active' : activeState='In Active'
                return(<tr>
                  <td>{seminar.id}</td>
                  <td>{seminar.name}</td>
                  <td>{seminar.full_name}</td>
                  <td>{seminar.event_date}</td>
                  <td><Button dense onClick={((e) => handleSeminarView(e, seminar.id))}>Update</Button></td>
                  <td><a href ={seminar.reg_link}>{seminar.reg_link}</a></td>
                  <td>{activeState}</td>
                  <td>{seminar.listing_sequence}</td>
                  <td>{seminar.session_no}</td>
                  <td>{seminar.ext_resource_id}</td>
               </tr>)
              })}
            </tbody> 
        )
      }

      let seminarUserImportComponent
      seminarUserImportComponent = (
        <GridCell span="12">
          <GridCell span="6">
              <Typography use="headline7" onClick={(e) => this.handleRendering(e, "upload", "new", '', "seminarUserImport")} style={{color: 'blue',textDecorationLine: 'underline'}}>Import New</Typography>
          </GridCell>
          <Typography use="caption">Info: Column name as follows Email,Seminar Id,First Name,Last Name</Typography> 
          <GridCell span="6">
            <Typography use="headline7" onClick={(e) => this.handleRendering(e, "view", "history", 0, "seminarUserImport")} style={{color: 'blue',textDecorationLine: 'underline'}}> View uploaded excel history</Typography>
          </GridCell>
        </GridCell>
        )

    return(
      <div>
        <Card style={{padding: '1px'}}>
          <Grid>
            <GridCell span="12">
              <Typography use="headline5">Seminar Details</Typography>
            </GridCell>
          </Grid>
        </Card>
        <br/>
        <GridCell span="12">
          <Card style={{padding: '15px'}}>
            <GridCell span="12">
              <Link to="/portal/app/admin/seminar/change/0"> Add Seminar </Link>
            </GridCell>
          </Card>
        </GridCell>
        <br/>
        <Card style={{padding: '15px'}}>
          <GridCell span="12">
            <GridCell span="12">
              <Typography use="headline7" style={{textDecorationLine: 'underline'}}><b>Seminar User Upload</b></Typography>
              {seminarUserImportComponent}
            </GridCell>
          </GridCell>
        </Card>
        <br/>
        <Grid>
          <GridCell span="12">
            <Typography use="headline7" style={{textDecorationLine: 'underline'}}><b>Export</b></Typography>
          </GridCell>
          {seminarListExportComponent}
          {seminarUserExportComponent}
          {SeminarResourceExportComponent}
          {/*<GridCell span="6">
            <Typography use="caption"><b>Note:</b> 1000 records per export</Typography>
          </GridCell>*/}
        </Grid>
        <ListDivider/>
        <Grid>
          <GridCell span="6">
          <Typography use="headline7" style={{textDecorationLine: 'underline'}}><b>Seminar List</b></Typography><br/>
            Total Pages - {this.state.data.totalPages}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <TextField  className='text_input' label="Page Number" autoComplete="off" name="page" onChange={this.onPageTextChange} value={this.state.page}/>
            <Button onClick={((e) => this.handleFetch(e))}>Fetch</Button>
          </GridCell>
          <GridCell span="6">
            <TextField  className='text_input' type="number" label="Certificate Id" autoComplete="off" name="seminarUserId" onChange={this.onInputChange} value={this.state.data.seminarUserId}/>
            &nbsp;
            <Button  onClick={((e) => this.fetchSpecificReport(e))} disabled={this.state.reportDownloadDisable}>Download</Button>
            <br/>
            <Typography use="caption">Download specific report</Typography>
          </GridCell>
          <GridCell span="12">
            <StatusMessage error_msg = {this.state.errorMsg}/>
          </GridCell>
        </Grid>
        <div>
          <table className="admin-table">
            <th>Id</th>
            <th>Name</th>
            <th>Seminar Full Name</th>
            <th>Event Date</th>
            <th>Action</th>
            <th>Registration Link</th>
            <th>Active</th>
            <th>Listing Sequence</th>
            <th>Session No</th>
            <th>Resource Id</th>  
            {seminarListComponent}
          </table>
        </div>
      </div>
    );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminSeminarList);


// WEBPACK FOOTER //
// ./src/views/admin/AdminSeminarList.jsx